import { Divider, Stack } from '@mui/material';
import CloseIcon from '../../../../../../../icons/CloseIcon';
import { Card, CardTitle, ClassCard, CourseCard, Dialog, Header, PollCard } from './styles';
import Typography from '../../../../../../../components/Typography';
import Footer from './Footer';
import { useTranslation } from 'react-i18next';
import { i18nNS } from '../../../../../../../i18n';
import { useCourseContext } from '../../../../../../course/Context';
import { usePollContext } from '../../../../../Context';
import { useClassContext } from '../../../../../../class/Context';

export interface InformationDialog {
  open: boolean;
  onClose: () => void;
}

const InformationDialog = ({ open, onClose }: InformationDialog) => {
  const { t } = useTranslation([i18nNS.POLL]);

  const { course } = useCourseContext();
  const { poll } = usePollContext();
  const { cls } = useClassContext();
  if (!course || !cls || !poll) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      header={(id: string) => (
        <Header
          id={id}
          right={{
            onClick: onClose,
            children: <CloseIcon size={24} color="inherit" aria-hidden />,
            size: 'xSmall',
          }}
        >
          <Typography variant="h6Bold">
            {t('how_to_participate_in_this_poll', { ns: i18nNS.POLL })}
          </Typography>
        </Header>
      )}
      footer={<Footer />}
    >
      <Divider />
      <Stack p={2} gap={2}>
        <Typography variant="paragraphBold" color="success.500" noWrap>
          {t('if_you_re_enrolled_in_the_course_course_code_course_title_that_truncates', {
            ns: i18nNS.POLL,
            courseCode: course.code,
            courseTitle: course.title,
          })}
        </Typography>
        <Typography variant="paragraphMedium" color="common.black">
          {t('log_in_to_acadly_app_on_your_mobile_devices_then', { ns: i18nNS.POLL })}
        </Typography>
        <Stack direction="row" p={1} gap={2}>
          <Card flex={1} p={2} gap={2}>
            <CardTitle>{t('step_1_colon_tap_on_the_course_card', { ns: i18nNS.POLL })}</CardTitle>
            <CourseCard course={course} />
          </Card>
          <Card flex={1} p={2} gap={2}>
            <CardTitle>{t('step_2_colon_go_to_this_lecture_on_timeline', { ns: i18nNS.POLL })}</CardTitle>
            <ClassCard course={course} cls={cls} />
          </Card>
          <Card flex={1} p={2} gap={2}>
            <CardTitle>{t('step_3_colon_tap_on_this_poll', { ns: i18nNS.POLL })}</CardTitle>
            <PollCard poll={poll} />
          </Card>
        </Stack>
      </Stack>
      <Divider />
    </Dialog>
  );
};

export default InformationDialog;
